import { getCookie } from '@beef/utils';

import { MOBILE_VIEW_COOKIE, MOBILE_VIEW_QUERY } from '../constants';
import { storeCookieFromSearchParam } from '../utils';

export const setMobileViewCookie = () => {
  storeCookieFromSearchParam(MOBILE_VIEW_COOKIE, MOBILE_VIEW_QUERY);
};

export const getIsWebview = (url = '') => {
  const isWebViewInUrl = url.split('?')[1]?.includes('webview');
  const isWebViewInUserAgent = isWebViewByUserAgent();
  const isWebViewInCookie = !!getCookie(MOBILE_VIEW_COOKIE);

  return isWebViewInUrl || isWebViewInUserAgent || isWebViewInCookie;
};

/** Определение webview через userAgent */
const isWebViewByUserAgent = () => {
  const { userAgent } = navigator;
  const userAgentLower = userAgent.toLowerCase();

  // 1) Определяем Android WebView
  const isAndroid = userAgentLower.includes('android');
  const isAndroidWebView =
    isAndroid &&
    (userAgentLower.includes('wv') || // признак webview
      userAgentLower.includes('version/')); // иногда встречается как "Version/4.0"

  // 2) Определяем iOS WebView
  const isIOS = /iPhone|iPad|iPod/.test(userAgent);
  const isSafari = /Safari/.test(userAgent) && !/CriOS|FxiOS|GSA/.test(userAgent);
  const isIOSWebView = isIOS && !isSafari;

  return isAndroidWebView || isIOSWebView;
};
